import React, { useContext } from "react";
import { Stack, Card, CardContent, Typography, Divider, Box } from "@mui/material";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { Link as RouterLink, useNavigate } from "react-router-dom";

export const PropertyDetailCard = React.memo(() => {
    const { listing, url } = useContext(InvestTransactionContext);
    const navigate = useNavigate();

    if (!listing?._id) return null; // Prevent rendering if listing is not loaded

    return (
        <Stack direction={"column"} spacing={2}>
            <Card sx={{ borderRadius: "10px" }}>
                <CardContent>
                    <Typography variant="body3" sx={{ fontWeight: 500 }}>Asset Details</Typography>
                    <Divider
                        sx={{
                            width: "calc(100% + 80px)",
                            margin: '15px -40px 24px'
                        }}
                    />
                    <Stack direction={"row"} spacing={{ md: 4, xs: 2 }}>
                        <Box
                            sx={{
                                paddingLeft: { md: "25%", xs: 0 },
                                background: `url('${url}${listing?.listingImages?.[0]?.docUrl}')`,
                                backgroundSize: "cover",
                                borderRadius: "10px",
                                width: { xs: "25%", md: "auto" },
                                minWidth: { xs: "25%", md: "auto" },
                                paddingTop: { xs: "25%", md: 0 },
                                height: { xs: "fit-content", md: "auto" },
                                ml: { md: 0, xs: 1 },
                                mt: { md: 0, xs: 1 }
                            }}
                        />
                        <Stack
                            direction={"column"}
                            paddingTop={{ md: 2, xs: 1 }}
                            paddingBottom={{ md: 4, xs: 1 }}
                            flex={1}
                        >
                            <Stack>
                                <Typography variant="caption">{listing?.propertyType}</Typography>
                                <Stack direction={"row"} spacing={2}>
                                    <Typography
                                        variant="headerMenu"
                                        sx={{ fontWeight: 600 }}
                                    >
                                        {listing?.title}&nbsp;&nbsp;-&nbsp;&nbsp;{listing?.project?.projectName}
                                    </Typography>
                                </Stack>
                                <Typography variant="caption">{listing?.developer?.username}</Typography>
                                <Stack direction={"row"} spacing={5} mt={2}>
                                    <Typography
                                        component={RouterLink}
                                        to={`/dashboard/property/${listing._id}`}
                                        state={{ id: listing._id }}
                                        variant="body2"
                                        sx={{ fontWeight: 500, cursor: "pointer" }}
                                    >
                                        View Details
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    );
});
